import React, { isValidElement } from 'react';
import {
    CircularProgress,
    CssBaseline,
} from '@material-ui/core';
import { withSnackbar } from 'notistack';
import { withStyles } from '@material-ui/core/styles';
import Layout from '../Layout';
import fetch, { fetchJson2 } from '../../utilities/fetch';
import ProductsTable from '../../components/v2/productsTable';
import ProductCreateDialog from '../../components/v2/productCreateDialog';
// import ProductEditDialog from '../../components/v2/manufacturerSupplierEditDialog';
// import ProductExpireDialog from '../../components/v2/manufacturerSupplierExpireDialog';

const { REACT_APP_API_SERVER } = process.env;

const styles = (theme) => ({
    inputLabel: {
        backgroundColor: '#fff',
        marginLeft: -5,
        paddingLeft: 8,
        paddingRight: 8,
    },
    menuFormControl: {
        marginBottom: theme.spacing.unit * 1,
        marginTop: theme.spacing.unit * 2,
    },
    newPurchaseOrderDialog: {
        maxWidth: 'none',
    },
    dialogContentContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    dialogButton: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 1,
    },
    dialogContent: {
        paddingBottom: 0,
        minWidth: 400,
    },
    dialogActions: {
        marginRight: theme.spacing.unit * 2.5,
    },
    itemsContainer: {
        marginTop: theme.spacing.unit * 2,
        marginBottom: theme.spacing.unit * 2,
    },
    itemsAddButtonContainer: {
        textAlign: 'right',
    },
    itemsTitleContainer: {
        marginTop: 13,
    },
    fieldAddButton: {
        marginLeft: 24,
        marginTop: 24,
    },
    radioGroup: {
        marginLeft: 24,
    },
    radioFormControl: {
        marginTop: 16,
    },
});

class Products extends React.Component {
    state = {
        currentProduct: {},
        errors: [],
        productsLoading: true,
        showCreateProductDialog: false,
        showEditProductDialog: false,
        showExpireProductDialog: false,
    };

    componentDidMount() {
        document.addEventListener('visibilitychange', this.onVisibilitychange);
        this.loadProductsData();
        this.loadManufacturers();
        this.loadProductTypes();
        this.loadProductTypeSubCategories();
        this.loadUser();
    }

    componentWillUnmount() {
        document.removeEventListener('visibilitychange', this.onVisibilitychange);
    }

    onVisibilitychange = () => {
        if (document.hidden === true) return;
        this.refreshVisitItemsData();
    };

    refreshProductsData = () => {
        this.loadProductsData().then(() => {
            this.props.enqueueSnackbar('UPDATED', { variant: 'success', autoHideDuration: 750 });
        }).catch(() => {
            this.props.enqueueSnackbar('UPDATE FAILED', { variant: 'error', autoHideDuration: 750 });
        });
    };

    loadProductsData = async () => {
        fetchJson2('v7/products')
            .then((products) => {
                this.setState({
                    products: products.payload,
                    productsLoading: false,
                });
            });
    };

    loadManufacturers = async () => {
        fetchJson2('v2/manufacturers')
            .then((manufacturers) => {
                this.setState({
                    manufacturers: manufacturers.payload,
                    manufacturersLoading: false,
                });
            });
    };

    loadProductTypes = async () => {
        fetchJson2('v2/product/types')
            .then((productTypes) => {
                this.setState({
                    productTypes: productTypes.payload,
                    productTypesLoading: false,
                });
            });
    };

    loadProductTypeSubCategories = async () => {
        fetchJson2('v2/product/type/subcategories')
            .then((productTypeSubCategories) => {
                this.setState({
                    productTypeSubCategories: productTypeSubCategories.payload,
                    productTypeSubCategoriesLoading: false,
                });
            });
    };

    loadUser = async () => {
        await fetchJson2('v2/user')
            .then((user) => {
                this.setState({
                    user: user.payload,
                    userLoading: false,
                });
            });
    };

    passNewProduct = (newProduct) => {
        console.log('>>> passNewProduct!!');
        let newProducts;
        if (!this.state.products.find((manufacturerSupplier) => manufacturerSupplier.code === newProduct.code)) {
            newProducts = [
                ...this.state.products,
                newProduct,
            ];
        } else {
            newProducts = this.state.products.map((manufacturerSupplier) => ((manufacturerSupplier.code === newProduct.code) ? newProduct : manufacturerSupplier));
        }
        this.setState({
            products: newProducts,
        });
    };

    handleExpireProductClick = (manufacturerSupplierCode, event) => {
        event.stopPropagation();
        const newCurrentProduct = this.state.products.find((manufacturerSupplier) => manufacturerSupplier.code === manufacturerSupplierCode);

        this.setState({
            currentProduct: {
                ...newCurrentProduct,
                histories: [],
            },
            showExpireProductDialog: true,
        });
    };

    handleCreateProductClick = () => {
        this.setState({
            showCreateProductDialog: true,
        });
    };

    handleEditProductClick = (manufacturerSupplierCode, event) => {
        event.stopPropagation();
        const newCurrentProduct = this.state.products.find((manufacturerSupplier) => manufacturerSupplier.code === manufacturerSupplierCode);
        this.setState({
            currentProduct: {
                ...newCurrentProduct,
                histories: [],
            },
            showEditProductDialog: true,
        });
    };

    handleCloseEditProductDialogClick = () => {
        this.setState({
            showEditProductDialog: false,
        });
    };

    handleCloseCreateProductDialogClick = () => {
        this.setState({
            showCreateProductDialog: false,
        });
    };

    handleCloseExpireProductDialogClick = () => {
        this.setState({
            showExpireProductDialog: false,
        });
    };

    unexpireProduct = async (manufacturerSupplierCode) => {
        let response;
        let body;

        try {
            response = await fetch(`${REACT_APP_API_SERVER}v2/manufacturerSupplier/${manufacturerSupplierCode}`, {
                body: JSON.stringify({ expired: 0 }),
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'PATCH',
            });
        } catch (e) {
            // something went really wrong; timeout/ blocked by client etc
            // debugger;
            console.log(e);
        }

        if (response.headers.get('content-type')
              && response.headers.get('content-type').search('application/json') >= 0) {
            body = await response.json();
        }
        switch (response.status) {
        case 200: {
            this.passNewProduct(body.manufacturerSupplier);
            break;
        }
        default: {
            throw new Error({ error: 'Generic API error' });
        }
        }
    };

    createProduct = async (payload) => {
        let response;
        let body;

        try {
            response = await fetch(`${REACT_APP_API_SERVER}v2/product/`, {
                body: JSON.stringify(payload),
                headers: {
                    'Content-Type': 'application/json',
                },
                method: 'POST',
            });
        } catch (e) {
            // something went really wrong; timeout/ blocked by client etc
            // debugger;
            console.log(e);
        }

        if (response.headers.get('content-type')
              && response.headers.get('content-type').search('application/json') >= 0) {
            body = await response.json();
        }
        switch (response.status) {
        case 200: {
            this.passNewProduct(body.product);
            break;
        }
        default: {
            throw new Error({ error: 'Generic API error' });
        }
        }
    };

    render() {
        const {
            classes,
        } = this.props;

        const {
            currentProduct,
            manufacturers,
            productsLoading,
            productTypes,
            productTypeSubCategories,
            showCreateProductDialog,
            showEditProductDialog,
            showExpireProductDialog,
            user,
            errors,
            products,
        } = this.state;

        return (
            <Layout pageTitle="Products">
                <CssBaseline />
                {
                    !productsLoading
                        ? (
                            <>
                                <ProductsTable
                                    editProduct={this.editProduct}
                                    errors={errors}
                                    expireProduct={this.expireProduct}
                                    handleCreateProductClick={this.handleCreateProductClick}
                                    handleExpireProductClick={this.handleExpireProductClick}
                                    handleEditProductClick={this.handleEditProductClick}
                                    handleCloseEditProductDialogClick={this.handleCloseEditProductDialogClick}
                                    handleCloseExpireProductDialogClick={this.handleCloseExpireProductDialogClick}
                                    user={user}
                                    products={products}
                                    productsLoading={productsLoading}
                                    passNewProduct={this.passNewProduct}
                                    unexpireProduct={this.unexpireProduct}
                                />
                                <ProductCreateDialog
                                    createProduct={this.createProduct}
                                    handleCloseCreateProductDialogClick={this.handleCloseCreateProductDialogClick}
                                    manufacturers={manufacturers}
                                    products={products}
                                    productsLoading={productsLoading}
                                    productTypes={productTypes}
                                    productTypeSubCategories={productTypeSubCategories}
                                    showCreateProductDialog={showCreateProductDialog}
                                    passNewProduct={this.passNewProduct}
                                />
                                {/* <ProductEditDialog
                                    handleCloseEditProductDialogClick={this.handleCloseEditProductDialogClick}
                                    manufacturerSupplier={currentProduct}
                                    manufacturerSupplierLoading={productsLoading}
                                    showEditProductDialog={showEditProductDialog}
                                    passNewProduct={this.passNewProduct}
                                />
                                <ProductExpireDialog
                                    handleCloseExpireProductDialogClick={this.handleCloseExpireProductDialogClick}
                                    handleExpireProductCloseDialogClick={this.handleExpireProductCloseDialogClick}
                                    manufacturerSupplier={currentProduct}
                                    manufacturerSupplierLoading={productsLoading}
                                    passNewProduct={this.passNewProduct}
                                    showExpireProductDialog={showExpireProductDialog}
                                /> */}
                            </>
                        )
                        : (
                            <div className={classes.progressContainer}>
                                <CircularProgress className={classes.progress} variant="indeterminate" />
                            </div>
                        )
                }

            </Layout>
        );
    }
}

export default withSnackbar(withStyles(styles)(Products));
